import React, { useEffect, useState } from "react";
import AllButton from "../../components/button/AllButton";
import HorizontalCard from "../../components/card/HorizontalCard";
import ImageCard from "../../components/card/ImageCard";
import VerticleCard from "../../components/card/VerticleCard";
import PageBanner from "../../components/PageBanner";
import NewsService from "../../services/news";
import ActivitiesService from "../../services/activities";
import GalleryService from "../../services/gallery";
import BannerService from "../../services/banner";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function News() {
  let [newsData, setNewsData] = useState([]);
  let [activitiesData, setActivitiesData] = useState([]);
  let [galleryData, setGalleryData] = useState([]);
  let [newsBanner, setNewsBanner] = useState([]);

  let { lang } = useParams();

  const history = useHistory();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getNewsData();
    getActivitiesData();
    getGalleryData();
    getNewsBanner();
  }, []);

  const getNewsData = async () => {
    try {
      let [res] = await NewsService.getMainpageNews({
        page: 1,
        pageSize: 3,
      });
      setNewsData(res);
    } catch {
      console.error();
    }
  };

  const getActivitiesData = async () => {
    try {
      let res = await ActivitiesService.getMainpageActivities();
      setActivitiesData(res);
    } catch {
      console.error();
    }
  };

  const getGalleryData = async () => {
    try {
      let [res] = await GalleryService.getGalleryBySize({
        pageSize: 3,
      });
      setGalleryData(res);
    } catch {
      console.error();
    }
  };

  const getNewsBanner = async () => {
    try {
      let res = await BannerService.getBanner(2);
      setNewsBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "News and Activity", href: "/newsAndActivity" }];

  return (
    <div id="news" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"ข่าวสารและกิจกรรม"}
        text_en={"News and Activity"}
        banner={newsBanner.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* ข่าวสาร */}
          <div id="news-section" className="pt-[92px]">
            <h1 className="text-[28px] xl:text-[32px] text-left">
              {lang === "th" ? "ข่าวสาร" : "News"}
            </h1>
            <div className="flex flex-col gap-[27px] mt-[38px]">
              {newsData &&
                newsData.map((item, i) => (
                  <HorizontalCard
                    data={item}
                    key={i}
                    page="newsAndActivity/news"
                    lang={lang}
                  />
                ))}
              <div className="flex justify-end">
                <span onClick={() => history.push("newsAndActivity/news")}>
                  <AllButton lang={lang} />
                </span>
              </div>
            </div>
          </div>

          {/* กิจกรรม */}
          <div id="activities-section" className="pt-[20px] mb-[57px]">
            <h1 className="text-[28px] xl:text-[32px] text-left">
              {lang === "th" ? "กิจกรรม" : "Activities"}
            </h1>
            <div id="news-activity" className="flex gap-[27px] mt-[38px]">
              {activitiesData &&
                activitiesData.map((item, i) => (
                  <VerticleCard
                    data={item}
                    key={i}
                    page="newsAndActivity/activity"
                    lang={lang}
                  />
                ))}
            </div>
            <div className="mt-[25px] flex justify-end">
              <span onClick={() => history.push("newsAndActivity/activity")}>
                <AllButton lang={lang} />
              </span>
            </div>
          </div>

          {/* ประมวลภาพกิจกรรม */}
          <div id="activities-image-section" className="pt-[20px] mb-[57px]">
            <h1 className="text-[28px] xl:text-[32px] text-left">
              {lang === "th" ? "ประมวลภาพกิจกรรม" : "Gallery"}
            </h1>
            <div
              id="image-activity"
              className="grid grid-cols-3 lg:flex-row gap-[30px] mt-[68px]"
            >
              {galleryData &&
                galleryData?.map((item, i) => (
                  <ImageCard data={item} key={i} lang={lang} />
                ))}
            </div>
            <div className="mt-[25px] flex justify-end">
              <span onClick={() => history.push(`/${lang}/gallery`)}>
                <AllButton lang={lang} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
